import dayjs from 'dayjs';

export function updateTicketExpiration (ticketExpiration: string): void {
	const dayJsValue = dayjs(ticketExpiration);
	if (dayJsValue.isValid()) {
		localStorage.setItem('ticketExpiration', dayJsValue.toISOString());
	}
}
